import React, { useState } from 'react'
import SuperICDandCPTSearch from '../../../../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import isNull from '../../../../../../../../../../../utils/NullChecking';
import handleNumericCheck from '../../../../../../../../../../../utils/HandleNumericKeys';

const ProcedureCodes = ({ widgetUtilities, ...props }) => {
    const {
        mainServiceLineModal,
        setMainServiceLineModal,
        serviceLineValidation,
        setServiceLineValidation,
        CPTModal,
        setCPTModal,
        cptBody,
        setcptBody,
        modifierBody,
        setmodifierBody,
        isProcedureEdit,
        setIsProcedureEdit,
        lastEncounterCPTs,
        RecentCPTs,
        RecentModifiers,
        isSuperbillEditAllowed,
        isClaimViewAllowed,
        isCreateClaimEditAllowed,
        dataExist,
        divClaimLinking,
        handleViewClaim,
        handleCreateClaim,
        handleApplyCPTs,
        handleAddNewCPT,
        areAllValuesNullOrEmpty,
        initialDataClaimID,
        initialDataEncounterID,
        assessmentData,
        API_URL,
    } = widgetUtilities;

    const [is, setIs] = useState(false);

    let SERVICE_LINE_MODAL = {
        "SuperBillID": "",
        "ProcedureCodeID": "",
        "ProcedureCode": "",
        "Pointer1": "",
        "Pointer2": "",
        "Pointer3": "",
        "Pointer4": "",
        "ModifierCodeID1": "",
        "ModifierCode1": "",
        "ModifierCodeID2": "",
        "ModifierCode2": "",
        "ModifierCodeID3": "",
        "ModifierCode3": "",
        "ModifierCodeID4": "",
        "ModifierCode4": "",
        "Units": "1",
        "Deleted": "false",
        "isUpdated": "false",
    };

    let ServiceLineValidation_Modal = {
        Pointer1Val: '',
        Pointer1UNI: '',
        Pointer2Val: '',
        Pointer2UNI: '',
        Pointer3Val: '',
        Pointer3UNI: '',
        Pointer4Val: '',
        Pointer4UNI: '',
        Pointer1ICD: '',
        Pointer2ICD: '',
        Pointer3ICD: '',
        Pointer4ICD: '',
        UnitsVal: '',
    };

    const handleEditProcedure = () => {
        if (!isSuperbillEditAllowed) return;
        setIsProcedureEdit(prev => !prev);
    };

    const handleServiceLineChange = (e, id, index, type, isMainCPTEncounterSOAP) => {
        if (!isSuperbillEditAllowed) return;
        setIs(false);
        let { name, value } = e.target;
        if (type === 'ProcedureCode') {
            setcptBody({ "TableName": 'Procedure', "SearchParam": value });
        } else if (type === 'Modifier') {
            setmodifierBody({ "TableName": 'Modifier', "SearchParam": value });
        }
        if (isMainCPTEncounterSOAP === "isMainCPTEncounterSOAP") {
            setCPTModal(prev => ({ ...prev, CPT: value }));
        } else {
            let serviceLineItem = [...mainServiceLineModal];
            serviceLineItem[index][name] = value;
            serviceLineItem[index]['isUpdated'] = 'true';
            setMainServiceLineModal(serviceLineItem);
        }
    };

    const handleOnblurServiceline = (e, index) => {
        const { value, name } = e.target;
        let serviceLineItem = [...mainServiceLineModal];
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));

        if (!serviceLineValidationCopy[index]) {
            serviceLineValidationCopy[index] = {};
        }

        if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
            let pointer1 = (serviceLineItem[index]['Pointer1'] || '') + "";
            let pointer2 = (serviceLineItem[index]['Pointer2'] || '') + "";
            let pointer3 = (serviceLineItem[index]['Pointer3'] || '') + "";
            let pointer4 = (serviceLineItem[index]['Pointer4'] || '') + "";
            let pointer = [pointer1, pointer2, pointer3, pointer4];
            let intValue = parseInt(value);
            let icdIndex = 'ICD' + value + 'Code';

            if ((intValue < 1 || intValue > 12) && !isNaN(intValue)) {
                serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12';
            } else if (icdIndex !== 'ICDCode') {
            } else {
                serviceLineValidationCopy[index][name + 'ICD'] = '';

                const uniqueSet = new Set();
                let hasDuplicates = false;

                for (const item of pointer) {
                    if (!isNull(item)) {
                        if (uniqueSet.has(item)) {
                            hasDuplicates = true;
                            break;
                        }
                        uniqueSet.add(item);
                    }
                }

                serviceLineValidationCopy[index]['Pointer1UNI'] = hasDuplicates
                    ? 'Pointers must be unique'
                    : '';
            }

            let foundNull = false;
            let Error = false;
            for (let i = 0; i < 4; i++) {
                if (isNull(pointer[i])) {
                    foundNull = true;
                }
                if (!isNull(pointer[i]) && foundNull === true) {
                    Error = true;
                }
            }

            serviceLineValidationCopy[index]['Pointer1Val'] = Error
                ? 'Pointers must be in sequence'
                : '';

            setServiceLineValidation(serviceLineValidationCopy);
        }
    };

    const handleSuperSearchList = (selectedData, index, name, isRecCPT, method) => {
        if (!isSuperbillEditAllowed) return;
        let data;
        if (isRecCPT === true) {
            if (method === 'CPT') {
                data = { value: selectedData[0].ProcedureCodeID, display: selectedData[0].ProcedureCode };
            } else {
                data = { value: selectedData[0].ProcedureMacroID, display: selectedData[0].Name };
            }
        } else if (isRecCPT === 'Modifier') {
            data = { value: selectedData[0].ModifierCodeID, display: selectedData[0].ModifierCode };
        } else {
            if (!isNull(selectedData)) {
                selectedData.isUpdated = "true";
                data = selectedData;
            }
        }
        setIs(true);
        let serviceLineItem = [...mainServiceLineModal];
        if (!isNull(data)) {
            if (name === 'ProcedureCode') {
                let newItem;
                const existingItem = serviceLineItem?.find(it => it.ProcedureCodeID == String(data.value));

                if (existingItem) {
                    if (existingItem.Deleted === "true") {
                        newItem = {
                            ...SERVICE_LINE_MODAL,
                            ProcedureCodeID: data.value + "",
                            [name]: data.display,
                            SuperBillID: existingItem.SuperBillID || "",
                            isUpdated: "true",
                        };

                        const index = serviceLineItem.indexOf(existingItem);
                        if (index !== -1) serviceLineItem[index] = newItem;
                        const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                        newValidationlist.push(ServiceLineValidation_Modal);
                        setServiceLineValidation(newValidationlist);
                    }
                } else {
                    newItem = {
                        ...SERVICE_LINE_MODAL,
                        ProcedureCodeID: data.value + "",
                        [name]: data.display,
                        isUpdated: "true",
                    };
                    serviceLineItem.push(newItem);
                    const newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
                    newValidationlist.push(ServiceLineValidation_Modal);
                    setServiceLineValidation(newValidationlist);
                }
            } else if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = data.value + "";
                serviceLineItem[index][name] = data.display;
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = data.value + "";
                serviceLineItem[index][name] = data.display;
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = data.value + "";
                serviceLineItem[index][name] = data.display;
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = data.value + "";
                serviceLineItem[index][name] = data.display;
                serviceLineItem[index]['isUpdated'] = data.isUpdated;
            }
        } else {
            if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = "";
                serviceLineItem[index][name] = '';
            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = "";
                serviceLineItem[index][name] = '';
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = "";
                serviceLineItem[index][name] = '';
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = "";
                serviceLineItem[index][name] = '';
            }
        }
        if (method === 'CPT') {
            setMainServiceLineModal(serviceLineItem);
            if (name === 'ProcedureCode') {
                setCPTModal(prev => ({ ...prev, CPT: '' }));
            }
        }
    };

    const handleDeleteRow = (index) => {
        const data = [...mainServiceLineModal];
        const validationList = [...serviceLineValidation];

        if (!data[index]?.SuperBillID) {
            data.splice(index, 1);
            validationList.splice(index, 1);
        } else {
            data[index].Deleted = "true";
            data[index].isUpdated = "true";
            if (validationList[index]) {
                validationList[index] = JSON.parse(JSON.stringify(ServiceLineValidation_Modal));
            }
        }
        setMainServiceLineModal(data);
        setServiceLineValidation(validationList);
    };

    return (
        <div className="d-flex gap-10">
        <div className="ar-form-counter flex-center">
            <p className='text text-black'>{props?.itemCount}</p>
        </div>
        <div className='bg_yellow p-2 w-100'>
            <div className="d-flex align-items-center justify-content-between">
                <p className='heading font-b fs-13 mb-1 leter-spacing' id={`SuperBill-${initialDataEncounterID}`}>SUPERBILL</p>
                <>
                    {!isNull(initialDataEncounterID) &&
                        (!isNull(initialDataClaimID) ?
                            (<div className={`d-flex align-items-center cursor-pointer ${isClaimViewAllowed ? '' : 'disable'}`}>
                                <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                                <i className='icon-enrollment fs-13 lh-9'></i>
                            </div>) :
                            <div className={`d-flex align-items-center cursor-pointer ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                                {(dataExist ?
                                    (divClaimLinking) :
                                    (
                                        mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                                            <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                                <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                                <i className='icon-enrollment fs-13 lh-9'></i>
                                            </div>
                                            :
                                            <></>
                                    ))}
                            </div>
                        )}
                </>
            </div>
            <div className="ar_content mb-2">
                <div className="d-flex align-items-center gap-1 icds-content">
                    <p className='heading pe-1'>ICD(s)</p>
                    {assessmentData?.EncounterProblem?.length > 0 &&
                        (assessmentData?.EncounterProblem?.map(prob => (
                            <p className='text'>{prob?.DiagnosisCode}</p>
                        )))}
                </div>
            </div>
            <div className="d-flex align-items-center gap-1 mb-1 justify-content-between">
                <div className='d-flex align-items-center gap-1'>
                    <p className='heading font-b fs-13 leter-spacing'>Procedure Codes</p>
                    <div className={`d-flex ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                        {isProcedureEdit ?
                            <i className='icon-x-cros gray-clr fw-900 fs-11"' onClick={handleEditProcedure}></i> :
                            <i className='icon-Icon-material-edit ar-light-color fs-11' onClick={handleEditProcedure}></i>}
                    </div>
                </div>
                <div className={`d-flex align-items-center gap-1 ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                    <div className="all_problems-preview position-relative">
                        {lastEncounterCPTs?.CPTs?.length > 0 ?
                            <>
                                <p className={`text validate-color cursor-pointer user-select-none ${isProcedureEdit ? 'br-right-1 br-clr pe-2' : ''}`} onClick={handleApplyCPTs}>{lastEncounterCPTs?.EncounterDate} - CPTs</p>
                                <div className="problem-content d-flex flex-column gap-2 hover-scrollbar ">
                                    {lastEncounterCPTs?.CPTs?.map(cpt => (
                                        <div className="d-flex align-items-center justify-content-between gap-20">
                                            <p className="text font-m">{cpt.ProcedureCode}</p>
                                            <p className="text font-m text-nowrap singleLine-ellispis" title={cpt?.Description}>{cpt?.Description}</p>
                                        </div>
                                    ))}
                                </div>
                            </> : <></>}
                    </div>
                    {isProcedureEdit ?
                        <div className='input claims_info problems-search'>
                            <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                            <div className="position-relative za-denied-status Icds">
                                <SuperICDandCPTSearch
                                    type='server'
                                    customData={RecentCPTs}
                                    placeholder={'Add Procedure'}
                                    id='ProcedureCode'
                                    name='ProcedureCode'
                                    onChange={(e) => handleServiceLineChange(e, 'data.RowID', 'index', 'ProcedureCode', 'isMainCPTEncounterSOAP')}
                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, 'index', 'ProcedureCode', false, 'CPT')}
                                    searchValue={CPTModal.CPT}
                                    searchBy={['display', 'Description']}
                                    tableData={[
                                        { columName: 'Code', bindingValue: 'display', },
                                        { columName: 'Description', bindingValue: 'Description', },
                                    ]}
                                    ApiLink={API_URL + "/CPTInstantSearch"}
                                    method='post'
                                    postBody={cptBody}
                                    disabled={true}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, 'index')}
                                    isReadOnly={!isSuperbillEditAllowed}
                                />
                            </div>
                        </div> : <></>}
                </div>
            </div>
            <div className="hk-expand-table overflow-auto BorderLess-table">
                <table className="w-100">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th className='w-212px'>Modifiers</th>
                            <th className='w-130px'>Pointers</th>
                            <th className='w-130px'>Units</th>
                            {isProcedureEdit ? <th className='w-0px'></th> : <></>}
                        </tr>
                    </thead>
                    {isProcedureEdit ?
                        <tbody>
                            <>
                                {mainServiceLineModal?.map((data, index) => {
                                    let displayProcedureCode = data?.ProcedureCode;
                                    let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index]);
                                    let amountVals = {}?.[data?.ServiceLineID];
                                    const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                                    let VISIT_PAYMENT_index = '';
                                    if (data?.Deleted !== "true") {
                                        return (
                                            <>
                                                <tr key={data.ServiceLineID}>
                                                    <td className='position-relative'>
                                                        <div className='input select-bg-img'>
                                                            {displayProcedureCode}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='hk-table-flex' >
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode1'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                                                    searchValue={data.ModifierCode1}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    placeholder={false}
                                                                    isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode2'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                                                    searchValue={data.ModifierCode2}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode3'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                                                    searchValue={data.ModifierCode3}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                />
                                                            </div>
                                                            <div>
                                                                <SuperICDandCPTSearch
                                                                    type='server'
                                                                    customData={RecentModifiers}
                                                                    id='Modifier Code'
                                                                    name='ModifierCode4'
                                                                    onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                    getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                                                    searchValue={data.ModifierCode4}
                                                                    searchBy={['display', 'Description']}
                                                                    tableData={[
                                                                        { columName: 'Code', bindingValue: 'display', },
                                                                        { columName: 'Description', bindingValue: 'Description', },
                                                                    ]}
                                                                    ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                    method='post'
                                                                    postBody={modifierBody}
                                                                    disabled={true}
                                                                    placeholder={false}
                                                                    sup_btn='sup_btn-Inp'
                                                                    sup_inp='superSearchVisitInp'
                                                                    isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='hk-table-flex'>
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer1"
                                                                id="Pointer1"
                                                                maxLength={2}
                                                                value={data.Pointer1}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                    !isNull(serviceLineValidation[index]?.Pointer2ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer2"
                                                                id="Pointer2"
                                                                maxLength={2}
                                                                value={data.Pointer2}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={
                                                                    !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer3ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer3"
                                                                id="Pointer3"
                                                                maxLength={2}
                                                                value={data.Pointer3}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                            <input
                                                                variant="outlined"
                                                                type="text"
                                                                className={
                                                                    !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                                                        !isNull(serviceLineValidation[index]?.Pointer4ICD) ? 'form-control input_error' : 'form-control'}
                                                                name="Pointer4"
                                                                id="Pointer4"
                                                                maxLength={2}
                                                                value={data.Pointer4}
                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                onKeyPress={handleNumericCheck}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className={`form-control units unit ${!isNull(serviceLineValidation[index]?.UnitsVal) ? 'error' : ''}`}
                                                            name="Units"
                                                            id="Units"
                                                            variant="outlined"
                                                            value={data.Units}
                                                            onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                                        />
                                                    </td>
                                                    <td className='text-center'>
                                                        <span onClick={() => handleDeleteRow(index)}><i class="fs-14 icon-delete" style={{ color: 'red' }}></i></span>
                                                    </td>
                                                </tr>
                                                {CheckValidation === true ? null :
                                                    <tr>
                                                        <td colSpan={12} className='message error_message'>
                                                            {!isNull(serviceLineValidation[index]?.DOSFromVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSFromVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.DOSToVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSToVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.CPTCodeVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1Val} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1UNI} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1Val} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1UNI} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer2ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer3ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer4ICD} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.POSVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.POSVal} </p> : null}
                                                            {!isNull(serviceLineValidation[index]?.UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.UnitsVal} </p> : null}
                                                        </td>
                                                    </tr>
                                                }
                                            </>
                                        )
                                    }
                                })}
                            </>
                        </tbody> :
                        <tbody>
                            {mainServiceLineModal?.map((data, index) => {
                                let displayProcedureCode = data?.ProcedureCode;
                                if (data?.Deleted !== "true") {
                                    return (
                                        <>
                                            <tr key={data.ServiceLineID}>
                                                <td className='position-relative'>
                                                    <div className='input select-bg-img'>
                                                        {displayProcedureCode}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='hk-table-flex' >
                                                        {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                            .filter(Boolean)
                                                            .join(', ')}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='hk-table-flex'>
                                                        {[data.Pointer1, data.Pointer2, data.Pointer3, data.Pointer4]
                                                            .filter(Boolean)
                                                            .join(', ')}
                                                    </div>
                                                </td>
                                                <td>{data.Units}</td>
                                            </tr>
                                        </>
                                    )
                                }
                            })}
                        </tbody>}
                </table>
            </div>
        </div>
        </div>
    );
};

export default ProcedureCodes;